module.exports = __webpack_public_path__ + "static/palitaw-sa-latik-6b2f0dd0e2c6d5364a56190de4030eba.jpg";